<lib-modal-base
  [visible]="isOpen()"
  [title]="'DID Document'"
  [description]="'View, copy, or download the complete DID document in JSON format.'"
  [size]="'large'"
  (handleClose)="onClose()"
>
  <div
    slot="content"
    class="modal-content-body"
  >
    <div class="json-container">
      <lib-json-display [json]="didDocument()"></lib-json-display>
    </div>

    <div class="modal-actions">
      <lib-button
        icon="copy"
        (clicked)="onCopy()"
      >
        {{ 'copy' | translate }}
      </lib-button>
      <lib-button
        icon="download"
        (clicked)="onDownload()"
      >
        {{ 'download' | translate }}
      </lib-button>
      <lib-button (clicked)="onClose()">
        {{ 'close' | translate }}
      </lib-button>
    </div>
  </div>
</lib-modal-base>
